import { ListFilterIcon, TagIcon, UserIcon } from 'lucide-vue-next';
import type { Component } from 'vue';

export type Filters = {
  assignee: AssigneeOption;
  taskType: TaskTypeOption;
  status: StatusOption;
};

export type TaskTypeOption = 'All' | 'Onboarding' | 'Offboarding' | 'Training' | 'One Off';
export type AssigneeOption = 'All' | 'Me' | 'Agent' | 'Others';
export type StatusOption = 'All' | 'Complete' | 'Incomplete';

type FilterConfig = {
  key: keyof Filters;
  label: string;
  options: readonly string[];
  icon: Component;
};

export const filterConfigList: FilterConfig[] = [
  {
    key: 'status',
    label: 'Status',
    options: ['Complete', 'Incomplete'],
    icon: ListFilterIcon,
  },
  {
    key: 'assignee',
    label: 'Assignee',
    options: ['Me', 'Agent', 'Others'],
    icon: UserIcon,
  },
  {
    key: 'taskType',
    label: 'Type',
    options: ['Onboarding', 'Offboarding', 'Training', 'One Off'],
    icon: TagIcon,
  },
];

export const defaultFilters: Filters = {
  assignee: 'All',
  taskType: 'All',
  status: 'Incomplete',
};
